import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import {
  CreateFormulaCardTypeMappingResponse,
  CreateFormulaCardTypeMappingVariables,
} from '../types';

const createFormulaCardTypeMappingMutation = gql`
  mutation OvertimeCreateFormulaCardTypeMapping($input: CreateOTFormulaCardTypeMappingInput!) {
    overtimeCreateFormulaCardTypeMapping(input: $input) {
      code
      success
      message
      data {
        typeMapping {
          id
          overtimeType
          formulaCardId
          createdAt
        }
      }
    }
  }
`;

const createFormulaCardTypeMapping = (queryVariables: CreateFormulaCardTypeMappingVariables) => {
  return graphQLApi<CreateFormulaCardTypeMappingResponse, CreateFormulaCardTypeMappingVariables>({
    query: createFormulaCardTypeMappingMutation,
    queryVariables,
  });
};

export default createFormulaCardTypeMapping;
